import {h, Fragment} from "preact"
import { useLoadMore } from '@nosto/preact';
import { useAppState } from '@nosto/preact';
import { useActions } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'
import { useFacets } from "@nosto/preact"
import { urlsToExclude } from '../helpers'

const teaTypeImages = {
    'Black': 'https://d21m4dsqdd3b9h.cloudfront.net/shopify-12341342/onsiteContent/17531081918600.06968518134551316',
    'Green': 'https://d21m4dsqdd3b9h.cloudfront.net/shopify-12341342/onsiteContent/17531081918610.6736916478095984',
    'Herbal': 'https://d21m4dsqdd3b9h.cloudfront.net/shopify-12341342/onsiteContent/17531081918600.3851939484379321',
    'Oolong': 'https://d21m4dsqdd3b9h.cloudfront.net/shopify-12341342/onsiteContent/17531081918610.5970261475160199',
    'Matcha': 'https://d21m4dsqdd3b9h.cloudfront.net/shopify-12341342/onsiteContent/16799458998200.8957831623939694',
    'White': 'https://d21m4dsqdd3b9h.cloudfront.net/shopify-12341342/onsiteContent/17531081918600.8446067097036632'
}

// const teaTypeStyles = {
//     'Black': 'tea-black',
//     'Green': 'tea-green',
//     'Herbal': 'tea-herbal',
//     'Oolong': 'tea-oolong',
//     'Matcha': 'tea-matcha',
//     'White': 'tea-white'
// }

export default function FilterByTeaType({ pageSize }) {
    const { loading, facets } = useFacets()
    const [selectedTeaType, setSelectedTeaType] = useState(null)
    const { toggleProductFilter } = useActions();

    const currentPath = typeof window !== 'undefined' ? window.location.pathname : ''
    const shouldExclude = urlsToExclude.some(url => currentPath.includes(url))
    
    if (shouldExclude) {
        return null
    }
    
    const teaTypeFacet = facets?.find(facet => facet.field === 'customFields.custom-tea_type')
    const teaTypes = teaTypeFacet?.data || []

    const handleTeaTypeClick = (teaType, value) => {
        const newSelection = selectedTeaType === teaType.value ? null : teaType.value
        setSelectedTeaType(newSelection)
        toggleProductFilter(
            'customFields.custom-tea_type',
            teaType.value,
            !teaType.selected
        )
        console.log('Selected tea type:', newSelection)
        // Example: applyFilter('customFields.custom-tea_type', newSelection)
    }
    
    if (loading) {
        return (
            <div className="filter-widget">
                <div className="filter-header">
                    <h2 className="filter-title">Filter By Tea Type</h2>
                </div>
                <div className="loading-placeholder">Loading tea types...</div>
            </div>
        )
    }
    
    if (!teaTypes.length || teaTypes.length <= 3) {
        return null
    }
    
    return (
        <>
            
            <div className="filter-widget">
                <div className="filter-header">
                    <h2 className="filter-title">Filter By Tea Type</h2>
                </div>
                
                <div className="tea-types-grid">
                    {teaTypes.map((teaType) => {
                        const imageUrl = teaTypeImages[teaType.value]
                        const isActive = teaType.selected
                        
                        return (
                            <div 
                                key={teaType.value}
                                className={`tea-type ${isActive ? 'active' : ''}`}
                                onClick={(e) => handleTeaTypeClick(teaType, teaType.value)}
                            >
                                <div 
                                    className="tea-circle"
                                    style={{ 
                                        backgroundImage: imageUrl ? `url(${imageUrl})` : 'none',
                                        backgroundColor: imageUrl ? 'white' : '#f0f0f0'
                                    }}
                                ></div>
                                <span className="tea-label">
                                    {teaType.value} ({teaType.count})
                                </span>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}